import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@material-ui/core';

import type { EmboldClientIdentifier } from 'utils/constants';
import { select } from 'store/toolkit';
import getTheme from './getTheme/index';

interface ThemeProviderProps {
  children: React.ReactNode;
}
export default function ThemeProvider({ children }: ThemeProviderProps): React.ReactNode {
  const clientName = useSelector(select.client.name) as EmboldClientIdentifier; // @TODO Typescript remove this after selectors have been typed
  const theme = getTheme(clientName);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}
